// Strings owned by the activity-heatmap widget. Day labels follow ISO
// ordering (Mon..Sun) — same as the API's `dayOfWeek` field.

export const ACTIVITY_HEATMAP_STRINGS = {
  title: "Activity heatmap",
  subtitle: "When the community talks (UTC, last 28 days)",
  empty: "No messages in the last 28 days yet.",
  legendLow: "Quiet",
  legendHigh: "Busiest",
  dayLabels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"] as const,
  /** "9:00" / "15:00" — 24h tick label. */
  hourTick: (hour: number): string => `${hour.toString().padStart(2, "0")}:00`,
  /** Tooltip — "Mon 09:00 · 12 messages". */
  cellTooltip: (params: {
    dayLabel: string;
    hour: number;
    messages: number;
  }): string => {
    const messageWord = params.messages === 1 ? "message" : "messages";
    return `${params.dayLabel} ${params.hour
      .toString()
      .padStart(2, "0")}:00 · ${params.messages} ${messageWord}`;
  },
} as const;

export type ActivityHeatmapStrings = typeof ACTIVITY_HEATMAP_STRINGS;
